import { render, staticRenderFns } from "./AllPuzzles.vue?vue&type=template&id=6506e201"
import script from "./AllPuzzles.vue?vue&type=script&lang=ts"
export * from "./AllPuzzles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports